import React from 'react'
import { ChevronLeft } from 'lucide-react'

const categories = {
  index: 'インデックス',
  stock: '個別株価',
  financial: '財務指標',
  macro: 'マクロ経済指標',
}

const subCategories = {
  index: {
    nikkei: { name: '日経平均', value: '32,034' },
    topix: { name: 'TOPIX', value: '2,701.54' },
    dowJones: { name: 'NY ダウ', value: '43,268.94' },
    sp500: { name: 'S&P 500', value: '5,916.98' },
  },
  stock: {
    toyota: { name: 'トヨタ自動車', value: '2,450' },
    sony: { name: 'ソニーグループ', value: '13,590' },
  },
  financial: {
    per: { name: 'PER', value: '' },
    pbr: { name: 'PBR', value: '' },
    roe: { name: 'ROE', value: '' },
  },
  macro: {
    gdp: { name: 'GDP', value: '536.8兆円' },
    cpi: { name: 'CPI', value: '104.3' },
    iip: { name: '鉱工業生産指数', value: '97.9' },
    housing: { name: '住宅着工件数', value: '860,000戸' },
  },
}

const MetricSelector = ({ isOpen, onClose, onSelect }) => {
  return (
    <div className={`fixed inset-y-0 right-0 w-[400px] bg-white shadow-lg transform ${isOpen ? 'translate-x-0' : 'translate-x-full'} transition-transform duration-300 ease-in-out z-50`}>
      <div className="p-4">
        <button
          className="mb-4 flex items-center text-gray-600 hover:text-gray-800"
          onClick={onClose}
        >
          <ChevronLeft className="w-5 h-5 mr-2" />
          戻る
        </button>
        <h5 className="text-lg font-semibold mb-4">指標を選択</h5>
        {Object.entries(categories).map(([categoryKey, categoryName]) => (
          <div key={categoryKey} className="mb-4">
            <h6 className="font-semibold mb-2">{categoryName}</h6>
            {Object.entries(subCategories[categoryKey]).map(([subCategoryKey, { name }]) => (
              <button
                key={subCategoryKey}
                className="block w-full text-left py-1 px-2 hover:bg-gray-100 rounded"
                onClick={() => onSelect(categoryKey, subCategoryKey)}
              >
                {name}
              </button>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}

export default MetricSelector